import React from "react"

import FormContainer from "../../components/FormContainer"
import Layout from "../../components/PublicLayout"
import SignInForm from "../../forms/SignIn"

export default function SignIn() {
  return (
    <Layout title="Sign In">
      <FormContainer>
        <SignInForm />
      </FormContainer>
    </Layout>
  )
}
